import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGlobalStore } from '@/store/global';
import { useEffect, useState } from 'react';
import { useCartStore } from '@/store/cart';
import { Loader } from 'google-maps';
function CartDeliveryPlace({ placeOfDelivery, setDeliveryPlace }) {
    const activePlaceOfDelivery = useCartStore((state) => state.activePlaceOfDelivery);
    const active = activePlaceOfDelivery?.id === placeOfDelivery.id;
    const handleClick = () => {
        setDeliveryPlace(placeOfDelivery);
    };
    return (_jsxs("div", { className: `list-group-item list-group-item-action ${active ? 'active' : ''}`, onClick: handleClick, children: [_jsx("div", { children: _jsx("i", { className: `fa-solid ${active ? 'fa-circle-check' : 'fa-location-pin'}` }) }), _jsx("div", { className: "title", children: placeOfDelivery.name }), _jsx("div", { className: "address", children: placeOfDelivery.address }), _jsx("div", { className: "opening", children: placeOfDelivery.opening_hours })] }));
}
export default function CartDeliveryPlaces({ deliveryPlaces }) {
    const googleApiKey = useGlobalStore((state) => state.config.integrations.google_api_key);
    const setActiveDeliveryPlace = useCartStore((state) => state.setActiveDeliveryPlace);
    const [googleMap, setGoogleMap] = useState();
    const [geometryLocations] = useState([]);
    const setDeliveryPlace = (placeOfDelivery) => {
        setActiveDeliveryPlace(placeOfDelivery);
        const geometry = geometryLocations.find(place => place.id === placeOfDelivery.id);
        if (googleMap && geometry) {
            googleMap.setCenter(geometry.location);
        }
    };
    useEffect(() => {
        if (googleMap) {
            deliveryPlaces.forEach(async (deliveryPlace) => {
                await new google.maps.Geocoder().geocode({
                    'address': deliveryPlace.address
                }, (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        googleMap.setCenter(results[0].geometry.location);
                        const location = results[0].geometry.location;
                        const marker = new google.maps.Marker({
                            position: location,
                            map: googleMap
                        });
                        google.maps.event.addListener(marker, 'click', () => {
                            setDeliveryPlace(deliveryPlace);
                        });
                        geometryLocations.push({ id: deliveryPlace.id, location: location });
                    }
                });
            });
        }
    }, [googleMap]);
    useEffect(() => {
        const loadGoogle = async () => {
            const options = {};
            const loader = new Loader(googleApiKey, options);
            const google = await loader.load();
            const mapDiv = document.getElementById('map');
            if (mapDiv) {
                setGoogleMap(new google.maps.Map(mapDiv, {
                    center: { lat: 49.9900, lng: 15.2567 },
                    zoom: 8,
                }));
            }
        };
        loadGoogle()
            .catch(console.error);
    }, []);
    return (_jsxs("div", { className: "row", children: [_jsx("div", { className: "col-12 col-lg-4", children: _jsx("div", { className: "list-group w-100", id: "map-delivery-list", children: deliveryPlaces.map((placeOfDelivery) => (_jsx(CartDeliveryPlace, { placeOfDelivery: placeOfDelivery, setDeliveryPlace: setDeliveryPlace }, placeOfDelivery.id))) }) }), _jsx("div", { className: "col-12 col-lg-8", children: _jsx("div", { id: "map", className: "w-100", style: { minHeight: "50vh" } }) })] }));
}
